import Constants from "config/Constants";

export interface AppRoutes {
  path: string;
  titleKey?: string;
}

const { routes } = Constants;

/**
 * Title routes for the authenticated app shell. `matchRoutes` ranks these by specificity,
 * so dynamic (`:id`) and child patterns resolve to the correct title.
 * The trailing `/*` entries keep the section title on nested paths that have no title
 * of their own (e.g. a dashboard detail view under `/dashboards`).
 */
export const PRIVATE_ROUTE_TITLES: AppRoutes[] = [
  ...Object.values(routes).map((route) => ({ path: route.route, titleKey: route.titleKey })),
  { path: `${routes.dashboard.route}/*`, titleKey: routes.dashboard.titleKey },
  { path: `${routes.exerciseLibrary.route}/*`, titleKey: routes.exerciseLibrary.titleKey },
  { path: `${routes.calendar.route}/*`, titleKey: routes.calendar.titleKey },
  { path: `${routes.workouts.route}/*`, titleKey: routes.workouts.titleKey },
  { path: `${routes.programs.route}/*`, titleKey: routes.programs.titleKey },
];

/**
 * Title routes for the unauthenticated shell. The public router renders Login at
 * "/", so "/" maps to the login title rather than the home title.
 */
export const PUBLIC_ROUTE_TITLES: AppRoutes[] = [{ path: "/", titleKey: routes.login.titleKey }];

/**
 * Title routes for the screens that are reachable signed in or signed out, so they
 * cannot be resolved from either of the lists above.
 */
export const NEUTRAL_ROUTE_TITLES: AppRoutes[] = [
  { path: routes.hyrox.route, titleKey: routes.hyrox.titleKey },
  { path: routes.join.route, titleKey: routes.join.titleKey },
  { path: routes.verifyEmail.route, titleKey: routes.verifyEmail.titleKey },
  { path: `${routes.verifyEmail.route}/*`, titleKey: routes.verifyEmail.titleKey },
  { path: routes.connect.route, titleKey: routes.connect.titleKey },
  { path: routes.integrationConnect.route, titleKey: routes.integrationConnect.titleKey },
];
